import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/sysWharf'

export function getAllSysWharf() {
    return request({
        url:`${BASE_REQUEST}/getAllSysWharf`
    })
}

export function getSysWharfList(querydata) {
        return request({
            url:`${BASE_REQUEST}/getSysWharfList`,
            data:querydata
        })
}

export function updateSysWharf(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/updateSysWharf`,
        data:obj
    })
}

export function delSysWharf(
    id
) {
    return request({
        url:`${BASE_REQUEST}/delSysWharf`,
        data:{id: id}
    })
}

export function saveSysWharf(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/saveSysWharf`,
        data:obj
    })
}

export function getSysWharfByName(
  name,region,port
) {
  return request({
    url:`${BASE_REQUEST}/getSysWharfByName`,
    data:{
      name: name,
      region:region,
      port:port
    }
  })
}
